import React from "react";

export default function InlineCheckboxComponent(props) {
  const { onCheck, label = "Lable", value, } = props;

  return (
    <div className="col-3">
      <div className="form-check form-check-inline">
        <input
          className={`form-check-input internship-months`}
          type="checkbox"
          value={value ? value : label}
          id={"lbl_" + value}
          onChange={(e) => onCheck(e)}
          //checked={checked}
        />
        <label className="form-check-label" htmlFor={"lbl_" + value}>
          {label}
        </label>
      </div>
    </div>
  );
}
